
  <div class="modal-content ">
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
        <div class="row">
          <div class="col-md-8">
            Review Activity
          </div>
          <div class="col-md-4">
            <button type="button" class="close" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>




      </div>
      <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
        <div class="modal-body padding-top-0px ">
          <div class="row border-top border-bottom  bk-color-light" *ngFor="let l of CurrentCounsellingPlanController">
            <div class="col-md-4  text-align-left border-right-1px">

              <div><label class="margin-bottom-0px font-size-14">{{l.DisplayName}}</label></div>
            </div>
            <div class="col-md-4  text-align-left border-right-1px">

              <div><label class="margin-bottom-0px font-size-14">{{l.Gender}},{{l.Age}}</label></div>
            </div>
            <div class="col-md-4 text-align-left border-right-1px">

              <div><label class="margin-bottom-0px font-size-14">{{l.Telephone1}}</label></div>
            </div>
          </div>
          <div class="row border-top border-bottom  bk-color-light" *ngFor="let l of CurrentCounsellingPlanController">
            <div class="col-md-4  text-align-left border-right-1px">

              <div><label class="margin-bottom-0px font-size-14 font-weight-bold">{{l.TreatmentPlan}}</label></div>
            </div>
            <!--<div class="col-md-3  text-align-left border-right-1px">

      <div><label class="margin-bottom-0px font-size-14">{{l.StartDate|date:'MMM-dd-yyyy'}}</label></div>
    </div>-->
            <div class="col-md-4 text-align-left border-right-1px">

              <div><label class="margin-bottom-0px font-size-14">{{l.FinancialStatus}}</label></div>
            </div>
            <div class="col-md-4 text-align-left border-right-1px">

              <div><label class="margin-bottom-0px font-size-14"><i class="fa fa-check margin-right-3px color-Assign" *ngIf="l.PlanStatus=='Active'"></i>{{l.PlanStatus}}</label></div>
            </div>
          </div>
          <!--<div class="row margin-top-10" *ngFor="let l of CurrentCounsellingPlanController">
    <div class="col-md-5">
      <div class="row">
        <div class="col-md-6 padding-right-0px">
          <label class="font-size-13px margin-bottom-0px">Created Date</label>
        </div>:
        <div class="col-md-5 padding-right-0px padding-left-0px">
          <label class="font-size-13px margin-bottom-0px">{{l.StartDate| date:'MMM-dd-yyyy'}}</label>
        </div>
      </div>

    </div>

  </div>-->
          <div class="row margin-top-10">
            <div class="col-md-5">
              <div class="row">
                <div class="col-md-6 padding-right-0px">
                  <label class="font-size-13px margin-bottom-0px">Schedule Date</label>
                </div>:
                <div class="col-md-5 padding-right-0px padding-left-0px">
                  <label class="font-size-13px margin-bottom-0px color-primary background-secondary padding-3px border-radius-3px margin-left-3px">{{ADate| date:'MMM-dd-yyyy'}}</label>
                </div>
              </div>

            </div>
            <div class="col-md-7 text-align-right">
              <div class="row">
                <div class="offset-md-5 col-md-5 padding-left-0px padding-right-0px">
                  <label class="font-size-13px margin-bottom-0px">Schedule Time</label>
                </div>:
                <div class="col-md-1 padding-right-0px padding-left-0px">
                  <label class="font-size-13px margin-bottom-0px">{{Time}}</label>
                </div>
              </div>
            </div>
          </div>

          <div class="row margin-left-auto margin-bottom-10px margin-top-10">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto ">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Actual Date</label>
                </div>


                <div class="col-md-6">
                  <div class="date-form">
                    <input class="form-control" placeholder="Actual Date"
                           name="dp" [(ngModel)]="ActualActivityDate" ngbDatepicker #d="ngbDatepicker" required #DateOfBirth="ngModel">
                    <small class="form-text text-danger"
                           *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                    <a (click)="d.toggle()" class="nav-link-hand">
                      <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                    </a>

                  </div>

                </div>
              </div>


            </div>
          </div>
          <div class="row margin-left-auto margin-bottom-10px">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto ">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"> Time</label>
                </div>


                <div class="col-md-6">
                  <input type="time" class="form-control"
                         id="CurrentEditCounsellingActivityRequest.ActualActivityTime" placeholder="Activity Time"
                         [(ngModel)]="CurrentEditCounsellingActivityRequest.ActualActivityTime"
                         name="CurrentEditCounsellingActivityRequest.ActualActivityTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" />

                </div>
              </div>


            </div>
          </div>
          <div class="row margin-left-auto margin-bottom-10px">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto ">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Follow-up Mode</label>
                </div>


                <div class="col-md-6">
                  <CodeTypeValue CodeType="FWUM"
                                 id="CurrentEditCounsellingActivityRequest.FollowupMode"
                                 [(ngModel)]="CurrentEditCounsellingActivityRequest.FollowupMode" SelectedValue="CurrentEditCounsellingActivityRequest.FollowupMode"
                                 name="CurrentEditCounsellingActivityRequest.FollowupMode" required>
                  </CodeTypeValue>

                </div>
              </div>


            </div>
          </div>
          <div class="row margin-left-auto margin-bottom-10px">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto ">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Follow-up Status</label>
                </div>


                <div class="col-md-6">
                  <CodeTypeValue CodeType="FWUS"
                                 id="CurrentEditCounsellingActivityRequest.Followupstatus"
                                 [(ngModel)]="CurrentEditCounsellingActivityRequest.Followupstatus" SelectedValue="CurrentEditCounsellingActivityRequest.Followupstatus"
                                 name="CurrentEditCounsellingActivityRequest.Followupstatus" required>
                  </CodeTypeValue>

                </div>
              </div>


            </div>
          </div>
          <div class="row margin-left-auto margin-bottom-10px">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Comments</label>
                </div>

                <div class="col-md-6">
                  <textarea class="form-control3 size-2 width-remarks-206px" rows="2" placeholder="Comments" minlength="1" maxlength="100"
                            name="CurrentEditCounsellingActivityRequest.Remarks"
                            [(ngModel)]="CurrentEditCounsellingActivityRequest.Remarks" required
                            #addconcerns_text="ngModel">
</textarea>
                </div>
              </div>


            </div>
          </div>


          <div class="row margin-top-10">
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-4 padding-right-0px">
                  <label class="font-size-13px margin-bottom-0px">Created By</label>
                </div>:
                <div class="col-md-7 text-align-left padding-right-5px padding-left-5px">
                  <label class="font-size-13px margin-bottom-0px">
                    {{CreatedUserName}}
                  </label>
                </div>
              </div>

            </div>
            <div class="col-md-6 text-align-right">
              <div class="row">
                <div class="col-md-4 padding-left-0px padding-right-0px">
                  <label class="font-size-13px margin-bottom-0px">Assigned To</label>
                </div>:
                <div class="col-md-7 text-align-left padding-right-5px padding-left-5px">
                  <label class="font-size-13px margin-bottom-0px">{{AssignedToName}}</label>
                </div>
              </div>
            </div>
          </div>


        </div>
        <div class="modal-footer padding-top-10px padding-bottom-10px">

          <!--<label class="font-size-14">CreatedUser :</label>
          <label class="margin-right-auto font-size-14 color-Assign">{{CreatedUserName}}</label>
          <label class="font-size-14">Assigned To :</label>
          <label class="margin-right-auto font-size-14 color-Assign">{{AssignedToName}}</label>-->
          <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3" (click)="activeModal.close('Close click')">Cancel</button>
          <button type="submit" *ngIf='!isRequesting && isvisible' class="btn font-size-13px actions-btn-prime">Save</button>

        </div>
        </form>
    </div>
  </div>
